// extracted by mini-css-extract-plugin
export default {"label":"EmailInput_label__RiLuW","input":"EmailInput_input__b-sea"};